// Collection Load More – Shopify Section Rendering API
// Lädt NUR die Product-Grid-Section (JSON), nicht die gesamte Seite → schnell
// Event Delegation → funktioniert auch nach Facetten/Sortier-Reload durch facets.js

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('#load-more-btn');
  if (!btn) return;

  const currentPage = parseInt(btn.dataset.currentPage, 10);
  const totalPages = parseInt(btn.dataset.totalPages, 10);
  const label = btn.dataset.label;
  const sectionId = btn.dataset.sectionId;

  if (currentPage >= totalPages) {
    btn.closest('.load-more-container').remove();
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Wird geladen …';

  const nextPage = currentPage + 1;
  const url = new URL(window.location.href);
  url.searchParams.set('page', nextPage);
  url.searchParams.set('sections', sectionId);

  try {
    const response = await fetch(url.toString());
    if (!response.ok) throw new Error('HTTP ' + response.status);

    // Shopify gibt JSON zurück: { "section-id": "<html-string>" }
    const data = await response.json();
    const sectionHtml = data[sectionId];

    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, 'text/html');

    const grid = document.getElementById('product-grid');
    const newItems = doc.querySelectorAll('#product-grid > li');
    const currentCount = grid ? grid.children.length : 0;

    newItems.forEach(function (item, i) {
      // Animation-Order für Scroll-Reveal korrekt weiterführen
      item.style.setProperty('--animation-order', currentCount + i + 1);
      grid.appendChild(item);
    });

    btn.dataset.currentPage = nextPage;

    if (nextPage >= totalPages) {
      btn.closest('.load-more-container').remove();
    } else {
      btn.disabled = false;
      btn.textContent = label;
    }
  } catch (err) {
    console.error('Load more fehlgeschlagen:', err);
    btn.disabled = false;
    btn.textContent = 'Fehler – erneut versuchen';
  }
});
